import Vue from "vue"
import vueResource from "vue-resource"
import md5 from 'js-md5'
import utils from './index'
Vue.use(vueResource)
// let baseUrl = 'api.d.blueshark.com'
// Vue.http.options.emulateJSON = true;
// Vue.http.options.headers = {
//   'Content-Type': 'application/json'
// }
// Vue.http.options.root = 'api.d.blueshark.com';
// Vue.http.interceptors.push((request, next) => {
//   let time = utils.getts()
//   let token = md5("BLUE" + time + "SHARK")
//   let header = {
//       Authorization: "Bearer " + token,
//       Ts: time
//     }
  
//   request.headers.set('TOKEN', "i am the token");//配置请求头
//   next((response) => {
//     if (!response) {
//     }
//     return response;
//   });
// });
export default {    
  post(url, req,api) {
    let time = utils.getts()
    let token = md5("BLUE" + time + "SHARK")
    let head=api?{
      Authorization: "Bearer " + token,
      Ts: time,
      'Content-Type': 'application/json'
    }:{
      Authorization: "Bearer " + token,
      Ts: time,
      SGAGENT:'PC|||||com.sharkgulf.blueshark',
      'Content-Type': 'application/json'
    }
    let header = {
            headers:head
      }
    let allUrl = api?(api+url):(API_HOST+url)
    return new Promise((resolve, reject) => {
      Vue.http.post(
        allUrl,
        req,
        header
      ).then(res => {
        resolve(res)
      }).catch((err) => {
        reject(err);
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/utils/request.js